import React from 'react';
import { Icon, Empty } from 'antd';

export function SpecificFloorPlanBlankTip({ t, onClickOpenModal }) {
  return (
    <div className="specific-floor-plan-blank-tip">
      <div className="specific-floor-plan-blank-tip__icon">
        <Empty description={false} />
      </div>
      <div className="specific-floor-plan-blank-tip__des">
        {t('cms:cms.property.listing_management.specific_floor_plan.panel.create')}
      </div>
      <span className="specific-floor-plan-blank-tip__link" onClick={onClickOpenModal}>
        <Icon type="edit" className="specific-floor-plan-blank-tip__link-icon" />
        {t('cms:cms.property.listing_management.floor_plan.modal.title')}
      </span>
    </div>
  );
}

export function CreateNewFloorButton({ onClick, t }) {
  return (
    <div className="specific-floor-create-btn" onClick={onClick}>
      <Icon type="edit" className="specific-floor-create-btn__icon" />
      {t('cms:cms.property.listing_management.floor_plan.modal.title')}
    </div>
  );
}
